import { usePusherEvent } from "PFCore/base/pusher";
import { useCurrentProfile } from "PFCore/hooks/queries/profile";
import { useProfilesInvalidate } from "PFCore/hooks/queries/profiles/use_profiles_invalidate";
import { useUserImportsInvalidate, useUsersImports } from "PFCore/hooks/queries/users";
import { UsersImport } from "PFCore/services/users/import";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { ImportModal, ImportModalPageType } from "../import_modal";
import { ImportUsersHistory } from "./import_users_history";
import { ImportUsersHistoryDetails } from "./import_users_history_details";
import { UsersUploadPage } from "./users_upload_page";

type ImportUsersModalProps = {
  onClose: VoidFunction;
};

export const ImportUsersModal = ({ onClose }: ImportUsersModalProps) => {
  const { data: currentProfile } = useCurrentProfile();
  const { t } = useTranslation("profiles", { keyPrefix: "importProfiles" });
  const [uploadSuccess, setUploadSuccess] = useState(false);

  const { data } = useUsersImports();
  const { invalidate: invalidateImports } = useUserImportsInvalidate();
  const { invalidate: invalidateProfiles } = useProfilesInvalidate();

  usePusherEvent(`private-profile-${currentProfile.id}`, "bulk_operation_completed", () => {
    invalidateImports();
    invalidateProfiles();
  });

  const handleImportSuccess = () => {
    invalidateImports();
    invalidateProfiles();
    setUploadSuccess(true);
  };

  const contentRenderer = useMemo(
    () => ({
      [ImportModalPageType.Upload]: () => <UsersUploadPage onSuccess={handleImportSuccess} />,
      [ImportModalPageType.ImportHistory]: () => <ImportUsersHistory />,
      [ImportModalPageType.ImportDataTable]: () => <ImportUsersHistoryDetails />
    }),
    []
  );

  return (
    <ImportModal<UsersImport>
      title={t("modalTitle")}
      onClose={onClose}
      importsCounter={data?.meta?.total}
      contentRenderer={contentRenderer}
      showOKButton={uploadSuccess}
    />
  );
};
